// i18n translations for Segreto Ristorante Italiano
// Default language: Polish

export const LANGS = ["pl", "en", "it", "de"];

const t = {
  pl: {
    nav: { home: "Start", about: "O nas", menu: "Menu", gallery: "Galeria", contact: "Kontakt", reserve: "Zadzwoń teraz" },
    common: {
      viewFullMenu: "Zobacz pełne menu", goToMenu: "Przejdź do menu", viewMenu: "Zobacz menu",
      callNow: "Zadzwoń teraz", callToReserve: "Zadzwoń, aby zarezerwować",
      directions: "Trasa dojazdu", getThere: "Jak do nas trafić",
      learnMore: "Poznaj Segreto", moreAboutUs: "Więcej o nas",
      viewGallery: "Zobacz galerię", seeLocation: "Zobacz lokalizację",
    },
    modal: {
      title: "Wybierz język", subtitle: "Choose your preferred language · Scegli la lingua · Sprache auswählen",
      pl: "Polski", en: "English", it: "Italiano", de: "Deutsch",
    },
    home: {
      heroEyebrow: "Pierwsza Dzielnica · Katowice",
      heroTitle1: "Segreto", heroTitle2: "Ristorante", heroTitle2b: "Italiano",
      heroSubtitle: "Włoski sekret w sercu Katowic",
      heroText: "Pizza rzymska, świeże makarony, włoskie dania, desery, kawa, wino i atmosfera, do której chce się wracać.",
      introEyebrow: "O Segreto",
      introTitle: "Włoska kuchnia",
      introTitle2: "w Pierwszej Dzielnicy",
      introP1: "Segreto Ristorante Italiano to miejsce dla osób, które cenią smak, atmosferę i spokojne spotkania przy stole. To dobra restauracja na kolację we dwoje, rodzinny obiad, spotkanie z przyjaciółmi albo wieczór przy winie.",
      introP2: "W menu znajdziesz pizzę rzymską, antipasti, makarony, dania główne, sałatki, desery, kawę, napoje, piwo, drinki i wino.",
      sigEyebrow: "Karta dań",
      sigTitle: "Smaki Segreto",
      sigIntro: "Wybierz coś lekkiego na początek, chrupiącą pizzę rzymską, aromatyczną pastę, danie główne albo kieliszek wina.",
      aboutEyebrow: "Wnętrze",
      aboutTitle: "Smak Italii",
      aboutTitle2: "w Katowicach",
      aboutP1: "W Segreto liczy się prostota, jakość składników i atmosfera przy stole. Pomidory, mozzarella, oliwa, bazylia, owoce morza, sery, świeże makarony i chrupiąca pizza rzymska tworzą menu inspirowane włoską kuchnią.",
      aboutP2: "Wnętrze restauracji ma własny charakter. Kolorowe murale, zieleń, ciepłe światło i wygodne stoliki tworzą klimat, który pasuje do długiej kolacji, spotkania z przyjaciółmi i spokojnego wieczoru przy winie.",
      aboutQuote: '"Klimat, który zostaje w pamięci."',
      menuEyebrow: "Menu z cenami",
      menuTitle: "Przejrzyj nasze",
      menuTitle2: "menu z cenami",
      menuText: "Sprawdź pełne menu Segreto Ristorante Italiano. Wybierz pizzę rzymską, antipasti, pastę, danie główne, kawę, napój albo drinka.",
      galleryEyebrow: "Galeria",
      galleryTitle: "Zobacz klimat Segreto",
      galleryText: "Wnętrze, mural, zieleń, światło, pasta, pizza, kawa i wino. Galeria pokazuje prawdziwy charakter restauracji.",
      galleryCard: "Włoska atmosfera",
      galleryCardText: "Pokaż pełną galerię restauracji.",
      reserveEyebrow: "Rezerwacja",
      reserveTitle: "Zarezerwuj stolik",
      reserveText: "Zarezerwuj stolik telefonicznie. Zadzwoń do nas i wybierz dogodny termin wizyty w Segreto Ristorante Italiano.",
      contactEyebrow: "Odwiedź nas",
      contactTitle: "Znajdź nas",
      contactTitle2: "w Katowicach",
      contactText: "Segreto Ristorante Italiano znajduje się w Katowicach, w Pierwszej Dzielnicy, przy ul. Henryka Mikołaja Góreckiego 13/2U.",
      sisterEyebrow: "Nasze miejsce nad morzem",
      sisterTitle: "Pizzeria Calabria",
      sisterTitle2: "w Kołobrzegu",
      sisterText: "Jeśli odwiedzasz Kołobrzeg, zapraszamy również do naszej siostrzanej restauracji Pizzeria Calabria. Miejsce blisko morza, stworzone na pizzę, włoskie smaki i spokojny posiłek po spacerze nad Bałtykiem.",
    },
    sigCards: [
      { title: "Pizza Rzymska", text: "Cienkie, kruche i chrupiące ciasto, sos pomidorowy, mozzarella i włoskie dodatki." },
      { title: "Antipasti", text: "Prosciutto, ricotta, mule, carpaccio, krewetki i włoskie przekąski." },
      { title: "Pasta", text: "Carbonara, Bolognese, owoce morza, krewetki, pesto i klasyczne włoskie sosy." },
      { title: "Dania Główne", text: "Ossobuco, Cotoletta alla Milanese i grillowana pierś z kurczaka." },
      { title: "Desery", text: "Słodkie zakończenie posiłku zgodnie z informacją u obsługi." },
      { title: "Kawa, napoje i wino", text: "Espresso, cappuccino, lemoniada, piwo, drinki, prosecco i wino." },
    ],
    about: {
      eyebrow: "O nas",
      title1: "Włoska restauracja", title2: "z charakterem",
      lead: "Segreto to nie tylko restauracja. To miejsce stworzone dla osób, które chcą zjeść dobrze, spokojnie i w przyjemnej atmosferze, w sercu Pierwszej Dzielnicy Katowic.",
      storyEyebrow: "Nasza historia",
      storyTitle1: "Włoski sekret", storyTitle2: "w sercu Katowic",
      storyP1: "Segreto Ristorante Italiano łączy włoskie smaki z ciepłym wnętrzem i nowoczesnym klimatem Pierwszej Dzielnicy w Katowicach. To przestrzeń na codzienny obiad, kolację po pracy, spotkanie z przyjaciółmi, rodzinny posiłek albo romantyczny wieczór.",
      storyP2: "Inspirujemy się włoską tradycją — od chrupiącej, cienkiej pizzy rzymskiej, przez świeże makarony i klasyczne sosy, po dania główne takie jak ossobuco czy cotoletta alla milanese. Najważniejsze są tutaj smak, gościnność i atmosfera, do której chce się wracać.",
      storyP3: "Wybierz coś lekkiego na początek, podziel się pizzą przy stole, sięgnij po kieliszek wina i zwolnij. Tak jada się we Włoszech — i tak jada się w Segreto.",
      stat1: "Rodzajów pizzy rzymskiej",
      stat2: "Sygnaturalnych past",
      stat3: "Kategorii w menu",
      stat4: "Pierwsza Dzielnica · Katowice",
      highlightsEyebrow: "Co znajdziesz w Segreto",
      highlightsTitle: "Włoska kuchnia w czterech smakach",
      highlights: [
        { title: "Pizza Rzymska",    text: "Cienkie, kruche i chrupiące ciasto, sos pomidorowy, mozzarella i włoskie dodatki." },
        { title: "Świeże Makarony",  text: "Carbonara, Bolognese, owoce morza, krewetki, pesto i klasyczne włoskie sosy." },
        { title: "Włoskie Wina",     text: "Prosecco, wina domowe i drinki frizzante na każdą okazję." },
        { title: "Espresso Italiano",text: "Espresso, cappuccino, latte i bombardino — kawa w prawdziwie włoskim stylu." },
      ],
      valuesEyebrow: "Nasza filozofia",
      valuesTitle: "Trzy zasady, które tworzą Segreto",
      values: [
        { title: "Prostota składników", text: "Pomidory, mozzarella, oliwa, bazylia, sery, owoce morza, wędliny — wszystko świeże, dobrze dobrane, bez zbędnych dodatków." },
        { title: "Atmosfera, która zostaje", text: "Kolorowe murale, zieleń na suficie, ciepłe światło, miękkie krzesła. Wnętrze, do którego chce się wracać." },
        { title: "Gościnność po włosku", text: "Spokojny serwis, czas na rozmowę, jedzenie dzielone przy stole. Tak jak w Rzymie albo Mediolanie." },
      ],
      quote: '"Wnętrze, kolorowy mural, ciepłe światło i smak Italii — Segreto to miejsce, które zapada w pamięć."',
      info1Title: "Lokalizacja",
      info2Title: "Godziny otwarcia",
      info3Title: "Idealne na",
      info3Text: "Kolację we dwoje, rodzinny obiad, spotkanie z przyjaciółmi i wieczór przy winie.",
      hoursShort: { mon: "Poniedziałek", monVal: "Zamknięte", weekday: "Wt – Pt", weekdayVal: "14:00 – 22:00", weekend: "Sob – Nd", weekendVal: "12:00 – 22:00" },
      ctaTitle: "Zapraszamy do stołu",
      ctaText: "Zarezerwuj stolik na kolację, rodzinny obiad albo spotkanie z przyjaciółmi. Zadzwoń lub wybierz wygodny termin.",
    },
    menu: {
      eyebrow: "Karta dań i napojów",
      title1: "Menu", title2: "Segreto",
      intro: "Pizza rzymska, antipasti, pasta, dania główne, desery, kawa, napoje i wino. Wszystkie ceny w PLN.",
      ctaTitle: "Smakuje? Zarezerwuj stolik.",
      ctaCall: "Zadzwoń",
      callLabel: "Zadzwoń:",
    },
    gallery: {
      eyebrow: "Galeria", title1: "Zobacz", title2: "klimat", title3: "Segreto",
      text: "Zobacz wnętrze restauracji, pizzę rzymską, makarony, desery, wino i atmosferę miejsca. Segreto to nie tylko restauracja, ale miejsce na spokojne spotkanie przy stole.",
      tags: ["Wnętrze", "Pizza", "Pasta", "Dania", "Desery", "Kawa", "Wino", "Spotkania"],
    },
    contact: {
      eyebrow: "Kontakt", title1: "Kontakt", title2: "i lokalizacja",
      lead: "Zapraszamy do Segreto Ristorante Italiano w Katowicach. Znajdziesz nas w Pierwszej Dzielnicy, przy ul. Henryka Mikołaja Góreckiego 13/2U.",
      address: "Adres", phone: "Telefon", hours: "Godziny otwarcia",
      callCardTitle: "Zadzwoń do nas",
      callCardText: "Rezerwacje stolików oraz kontakt z restauracją odbywają się wyłącznie telefonicznie.",
    },
    footer: {
      info: "Informacja",
      disclaimer: "Menu, ceny, dostępność dań, napojów oraz godziny otwarcia mogą ulec zmianie. Informacje na stronie mają charakter informacyjny i nie stanowią oferty handlowej w rozumieniu przepisów prawa. Aktualne informacje prosimy potwierdzić bezpośrednio w restauracji lub u obsługi.",
      tagline: "Włoska restauracja w Katowicach.",
      blurb: "Pizza rzymska, pasta, włoskie dania, kawa, napoje, wino i przyjemna atmosfera w Pierwszej Dzielnicy Katowic.",
      nav: "Nawigacja", contact: "Kontakt", social: "Sociale",
      phoneLabel: "Telefon",
      rights: "Wszystkie prawa zastrzeżone.",
      socialFollow1: "Instagram", socialFollow2: "Facebook", socialFollow3: "Google Maps",
      socialSubtitle3: "Znajdź nas na mapie",
    },
    hours: [
      { day: "Poniedziałek", value: "Zamknięte" },
      { day: "Wtorek",       value: "14:00 – 22:00" },
      { day: "Środa",        value: "14:00 – 22:00" },
      { day: "Czwartek",     value: "14:00 – 22:00" },
      { day: "Piątek",       value: "14:00 – 22:00" },
      { day: "Sobota",       value: "12:00 – 22:00" },
      { day: "Niedziela",    value: "12:00 – 22:00" },
    ],
  },

  en: {
    nav: { home: "Home", about: "About", menu: "Menu", gallery: "Gallery", contact: "Contact", reserve: "Call now" },
    common: {
      viewFullMenu: "View full menu", goToMenu: "Go to menu", viewMenu: "View menu",
      callNow: "Call now", callToReserve: "Call to reserve",
      directions: "Directions", getThere: "How to find us",
      learnMore: "Discover Segreto", moreAboutUs: "More about us",
      viewGallery: "View gallery", seeLocation: "See location",
    },
    modal: {
      title: "Choose your preferred language", subtitle: "Wybierz język · Scegli la lingua · Sprache auswählen",
      pl: "Polski", en: "English", it: "Italiano", de: "Deutsch",
    },
    home: {
      heroEyebrow: "Pierwsza Dzielnica · Katowice",
      heroTitle1: "Segreto", heroTitle2: "Ristorante", heroTitle2b: "Italiano",
      heroSubtitle: "An Italian secret in the heart of Katowice",
      heroText: "Roman pizza, fresh pasta, Italian dishes, desserts, coffee, wine and an atmosphere you'll want to return to.",
      introEyebrow: "About Segreto",
      introTitle: "Italian cuisine",
      introTitle2: "in the First District",
      introP1: "Segreto Ristorante Italiano is a place for people who appreciate taste, atmosphere and quiet gatherings at the table. A great restaurant for a dinner for two, a family lunch, a meeting with friends or an evening over wine.",
      introP2: "On the menu you'll find Roman pizza, antipasti, pasta, main courses, salads, desserts, coffee, soft drinks, beer, cocktails and wine.",
      sigEyebrow: "Our menu",
      sigTitle: "Tastes of Segreto",
      sigIntro: "Choose something light to start, a crispy Roman pizza, an aromatic pasta, a main course or a glass of wine.",
      aboutEyebrow: "Interior",
      aboutTitle: "A taste of Italy",
      aboutTitle2: "in Katowice",
      aboutP1: "At Segreto, what matters is simplicity, quality ingredients and the atmosphere at the table. Tomatoes, mozzarella, olive oil, basil, seafood, cheese, fresh pasta and crispy Roman pizza make up a menu inspired by Italian cuisine.",
      aboutP2: "The restaurant interior has its own character. Colourful murals, greenery, warm light and comfortable tables create an ambience that suits a long dinner, a meeting with friends and a quiet evening with wine.",
      aboutQuote: '"An atmosphere that stays in your memory."',
      menuEyebrow: "Menu with prices",
      menuTitle: "Browse our",
      menuTitle2: "menu with prices",
      menuText: "Check the full menu of Segreto Ristorante Italiano. Choose Roman pizza, antipasti, pasta, a main course, coffee, a drink or a cocktail.",
      galleryEyebrow: "Gallery",
      galleryTitle: "Discover the Segreto vibe",
      galleryText: "Interior, mural, greenery, lighting, pasta, pizza, coffee and wine. The gallery shows the real character of the restaurant.",
      galleryCard: "Italian atmosphere",
      galleryCardText: "See the full gallery of the restaurant.",
      reserveEyebrow: "Reservations",
      reserveTitle: "Book a table",
      reserveText: "Reserve a table by phone. Call us and pick a convenient time to visit Segreto Ristorante Italiano.",
      contactEyebrow: "Visit us",
      contactTitle: "Find us",
      contactTitle2: "in Katowice",
      contactText: "Segreto Ristorante Italiano is located in Katowice, in the First District, at ul. Henryka Mikołaja Góreckiego 13/2U.",
      sisterEyebrow: "Our place by the sea",
      sisterTitle: "Pizzeria Calabria",
      sisterTitle2: "in Kołobrzeg",
      sisterText: "If you're visiting Kołobrzeg, we also invite you to our sister restaurant Pizzeria Calabria. A place close to the sea, made for pizza, Italian flavours and a quiet meal after a walk by the Baltic.",
    },
    sigCards: [
      { title: "Roman Pizza", text: "Thin, crisp and crunchy dough, tomato sauce, mozzarella and Italian toppings." },
      { title: "Antipasti", text: "Prosciutto, ricotta, mussels, carpaccio, shrimp and Italian starters." },
      { title: "Pasta", text: "Carbonara, Bolognese, seafood, shrimp, pesto and classic Italian sauces." },
      { title: "Main Courses", text: "Ossobuco, Cotoletta alla Milanese and grilled chicken breast." },
      { title: "Desserts", text: "A sweet finish to your meal — please ask our staff for details." },
      { title: "Coffee, drinks & wine", text: "Espresso, cappuccino, lemonade, beer, cocktails, prosecco and wine." },
    ],
    about: {
      eyebrow: "About us",
      title1: "An Italian restaurant", title2: "with character",
      lead: "Segreto is more than a restaurant. It's a place for people who want to eat well, calmly and in a pleasant atmosphere, in the heart of the First District of Katowice.",
      storyEyebrow: "Our story",
      storyTitle1: "An Italian secret", storyTitle2: "in the heart of Katowice",
      storyP1: "Segreto Ristorante Italiano combines Italian flavours with a warm interior and the modern feel of the First District in Katowice. A space for an everyday lunch, dinner after work, a meeting with friends, a family meal or a romantic evening.",
      storyP2: "We draw inspiration from Italian tradition — from crispy, thin Roman pizza, through fresh pasta and classic sauces, to main courses such as ossobuco or cotoletta alla milanese. Taste, hospitality and an atmosphere worth returning to come first here.",
      storyP3: "Pick something light to start, share a pizza at the table, reach for a glass of wine and slow down. That's how Italy eats — and that's how Segreto eats.",
      stat1: "Roman pizza varieties",
      stat2: "Signature pastas",
      stat3: "Menu categories",
      stat4: "First District · Katowice",
      highlightsEyebrow: "What you'll find at Segreto",
      highlightsTitle: "Italian cuisine in four flavours",
      highlights: [
        { title: "Roman Pizza",       text: "Thin, crisp and crunchy dough, tomato sauce, mozzarella and Italian toppings." },
        { title: "Fresh Pasta",       text: "Carbonara, Bolognese, seafood, shrimp, pesto and classic Italian sauces." },
        { title: "Italian Wines",     text: "Prosecco, house wines and frizzante cocktails for every occasion." },
        { title: "Italian Espresso",  text: "Espresso, cappuccino, latte and bombardino — coffee in true Italian style." },
      ],
      valuesEyebrow: "Our philosophy",
      valuesTitle: "Three principles that make Segreto",
      values: [
        { title: "Simple ingredients",       text: "Tomatoes, mozzarella, olive oil, basil, cheese, seafood, cold cuts — all fresh, carefully chosen, with nothing unnecessary." },
        { title: "Atmosphere that stays",    text: "Colourful murals, greenery on the ceiling, warm light, soft chairs. An interior worth returning to." },
        { title: "Italian hospitality",      text: "Calm service, time to talk, food shared at the table. Just like in Rome or Milan." },
      ],
      quote: '"The interior, the colourful mural, the warm light and the taste of Italy — Segreto is a place that stays in your memory."',
      info1Title: "Location",
      info2Title: "Opening hours",
      info3Title: "Perfect for",
      info3Text: "A dinner for two, a family lunch, a meeting with friends and an evening over wine.",
      hoursShort: { mon: "Monday", monVal: "Closed", weekday: "Tue – Fri", weekdayVal: "2:00 PM – 10:00 PM", weekend: "Sat – Sun", weekendVal: "12:00 PM – 10:00 PM" },
      ctaTitle: "Welcome to our table",
      ctaText: "Book a table for dinner, a family lunch or a meeting with friends. Call or choose a convenient time.",
    },
    menu: {
      eyebrow: "Food & drinks menu",
      title1: "The", title2: "Segreto Menu",
      intro: "Roman pizza, antipasti, pasta, main courses, desserts, coffee, soft drinks and wine. All prices in PLN.",
      ctaTitle: "Hungry? Book a table.",
      ctaCall: "Call",
      callLabel: "Call:",
    },
    gallery: {
      eyebrow: "Gallery", title1: "Discover the", title2: "vibe", title3: "of Segreto",
      text: "See the restaurant interior, Roman pizza, pasta, desserts, wine and the atmosphere of the place. Segreto is more than a restaurant — it's a place for a peaceful meeting at the table.",
      tags: ["Interior", "Pizza", "Pasta", "Mains", "Desserts", "Coffee", "Wine", "Gatherings"],
    },
    contact: {
      eyebrow: "Contact", title1: "Contact", title2: "& location",
      lead: "Welcome to Segreto Ristorante Italiano in Katowice. You'll find us in the First District, at ul. Henryka Mikołaja Góreckiego 13/2U.",
      address: "Address", phone: "Phone", hours: "Opening hours",
      callCardTitle: "Call us",
      callCardText: "Table reservations and contact with the restaurant are accepted by phone only.",
    },
    footer: {
      info: "Information",
      disclaimer: "Menu, prices, availability of dishes, drinks and opening hours may change. The information on this website is for reference only and does not constitute a commercial offer within the meaning of the law. Please confirm current information directly with the restaurant or staff.",
      tagline: "Italian restaurant in Katowice.",
      blurb: "Roman pizza, pasta, Italian dishes, coffee, soft drinks, wine and a pleasant atmosphere in the First District of Katowice.",
      nav: "Navigation", contact: "Contact", social: "Social",
      phoneLabel: "Phone",
      rights: "All rights reserved.",
      socialFollow1: "Instagram", socialFollow2: "Facebook", socialFollow3: "Google Maps",
      socialSubtitle3: "Find us on the map",
    },
    hours: [
      { day: "Monday",    value: "Closed" },
      { day: "Tuesday",   value: "2:00 PM – 10:00 PM" },
      { day: "Wednesday", value: "2:00 PM – 10:00 PM" },
      { day: "Thursday",  value: "2:00 PM – 10:00 PM" },
      { day: "Friday",    value: "2:00 PM – 10:00 PM" },
      { day: "Saturday",  value: "12:00 PM – 10:00 PM" },
      { day: "Sunday",    value: "12:00 PM – 10:00 PM" },
    ],
  },

  it: {
    nav: { home: "Home", about: "Chi siamo", menu: "Menù", gallery: "Galleria", contact: "Contatti", reserve: "Chiama ora" },
    common: {
      viewFullMenu: "Vedi il menù completo", goToMenu: "Vai al menù", viewMenu: "Vedi il menù",
      callNow: "Chiama ora", callToReserve: "Chiama per prenotare",
      directions: "Indicazioni", getThere: "Come trovarci",
      learnMore: "Scopri Segreto", moreAboutUs: "Maggiori informazioni",
      viewGallery: "Vedi la galleria", seeLocation: "Vedi la posizione",
    },
    modal: {
      title: "Scegli la lingua", subtitle: "Wybierz język · Choose your preferred language · Sprache auswählen",
      pl: "Polski", en: "English", it: "Italiano", de: "Deutsch",
    },
    home: {
      heroEyebrow: "Pierwsza Dzielnica · Katowice",
      heroTitle1: "Segreto", heroTitle2: "Ristorante", heroTitle2b: "Italiano",
      heroSubtitle: "Un segreto italiano nel cuore di Katowice",
      heroText: "Pizza romana, pasta fresca, piatti italiani, dolci, caffè, vino e un'atmosfera a cui si vuole tornare.",
      introEyebrow: "Su Segreto",
      introTitle: "Cucina italiana",
      introTitle2: "nella Pierwsza Dzielnica",
      introP1: "Segreto Ristorante Italiano è un luogo per chi apprezza il gusto, l'atmosfera e i tranquilli incontri a tavola. Un buon ristorante per una cena a due, un pranzo in famiglia, un incontro con amici o una serata davanti a un bicchiere di vino.",
      introP2: "Nel menù trovi pizza romana, antipasti, pasta, secondi piatti, insalate, dolci, caffè, bevande, birra, cocktail e vino.",
      sigEyebrow: "Il nostro menù",
      sigTitle: "I sapori di Segreto",
      sigIntro: "Scegli qualcosa di leggero per iniziare, una croccante pizza romana, una pasta aromatica, un secondo o un calice di vino.",
      aboutEyebrow: "Interni",
      aboutTitle: "Un sapore d'Italia",
      aboutTitle2: "a Katowice",
      aboutP1: "Da Segreto contano la semplicità, la qualità degli ingredienti e l'atmosfera a tavola. Pomodori, mozzarella, olio d'oliva, basilico, frutti di mare, formaggi, pasta fresca e croccante pizza romana compongono un menù ispirato alla cucina italiana.",
      aboutP2: "L'interno del ristorante ha un carattere proprio. Murales colorati, verde, luce calda e tavoli accoglienti creano un'atmosfera perfetta per una lunga cena, un incontro con amici e una serata tranquilla davanti a un bicchiere di vino.",
      aboutQuote: '"Un\'atmosfera che resta nella memoria."',
      menuEyebrow: "Menù con prezzi",
      menuTitle: "Sfoglia il nostro",
      menuTitle2: "menù con prezzi",
      menuText: "Consulta il menù completo di Segreto Ristorante Italiano. Scegli pizza romana, antipasti, pasta, un secondo, caffè, una bevanda o un cocktail.",
      galleryEyebrow: "Galleria",
      galleryTitle: "Scopri l'atmosfera di Segreto",
      galleryText: "Interni, murales, verde, luci, pasta, pizza, caffè e vino. La galleria mostra il vero carattere del ristorante.",
      galleryCard: "Atmosfera italiana",
      galleryCardText: "Guarda la galleria completa del ristorante.",
      reserveEyebrow: "Prenotazioni",
      reserveTitle: "Prenota un tavolo",
      reserveText: "Prenota un tavolo telefonicamente. Chiamaci e scegli l'orario più comodo per la tua visita a Segreto Ristorante Italiano.",
      contactEyebrow: "Vienici a trovare",
      contactTitle: "Trovaci",
      contactTitle2: "a Katowice",
      contactText: "Segreto Ristorante Italiano si trova a Katowice, nella Pierwsza Dzielnica, in ul. Henryka Mikołaja Góreckiego 13/2U.",
      sisterEyebrow: "Il nostro posto al mare",
      sisterTitle: "Pizzeria Calabria",
      sisterTitle2: "a Kołobrzeg",
      sisterText: "Se visiti Kołobrzeg, ti invitiamo anche al nostro ristorante gemello Pizzeria Calabria. Un luogo vicino al mare, pensato per la pizza, i sapori italiani e un pasto tranquillo dopo una passeggiata sul Baltico.",
    },
    sigCards: [
      { title: "Pizza Romana", text: "Impasto sottile, friabile e croccante, salsa di pomodoro, mozzarella e ingredienti italiani." },
      { title: "Antipasti", text: "Prosciutto, ricotta, cozze, carpaccio, gamberetti e altri antipasti italiani." },
      { title: "Pasta", text: "Carbonara, Bolognese, frutti di mare, gamberetti, pesto e classici sughi italiani." },
      { title: "Secondi", text: "Ossobuco, Cotoletta alla Milanese e petto di pollo alla griglia." },
      { title: "Dolci", text: "Un dolce per concludere il pasto — chiedi al personale per i dettagli." },
      { title: "Caffè, bevande e vino", text: "Espresso, cappuccino, limonata, birra, cocktail, prosecco e vino." },
    ],
    about: {
      eyebrow: "Chi siamo",
      title1: "Un ristorante italiano", title2: "con carattere",
      lead: "Segreto non è solo un ristorante. È un luogo creato per chi vuole mangiare bene, in tranquillità e in un'atmosfera piacevole, nel cuore della Pierwsza Dzielnica di Katowice.",
      storyEyebrow: "La nostra storia",
      storyTitle1: "Un segreto italiano", storyTitle2: "nel cuore di Katowice",
      storyP1: "Segreto Ristorante Italiano unisce i sapori italiani a un interno caldo e all'atmosfera moderna della Pierwsza Dzielnica di Katowice. Uno spazio per il pranzo di tutti i giorni, una cena dopo il lavoro, un incontro con amici, un pasto in famiglia o una serata romantica.",
      storyP2: "Ci ispiriamo alla tradizione italiana — dalla croccante pizza romana sottile, alla pasta fresca e ai sughi classici, fino ai secondi come ossobuco o cotoletta alla milanese. Qui contano il gusto, l'ospitalità e un'atmosfera a cui si vuole tornare.",
      storyP3: "Scegli qualcosa di leggero per iniziare, condividi una pizza al tavolo, prendi un calice di vino e rallenta. Così si mangia in Italia — e così si mangia da Segreto.",
      stat1: "Tipi di pizza romana",
      stat2: "Paste della casa",
      stat3: "Categorie nel menù",
      stat4: "Pierwsza Dzielnica · Katowice",
      highlightsEyebrow: "Cosa troverai da Segreto",
      highlightsTitle: "Cucina italiana in quattro sapori",
      highlights: [
        { title: "Pizza Romana",       text: "Impasto sottile, friabile e croccante, salsa di pomodoro, mozzarella e ingredienti italiani." },
        { title: "Pasta Fresca",       text: "Carbonara, Bolognese, frutti di mare, gamberetti, pesto e classici sughi italiani." },
        { title: "Vini Italiani",      text: "Prosecco, vini della casa e cocktail frizzante per ogni occasione." },
        { title: "Espresso Italiano",  text: "Espresso, cappuccino, latte e bombardino — caffè in vero stile italiano." },
      ],
      valuesEyebrow: "La nostra filosofia",
      valuesTitle: "Tre principi che fanno Segreto",
      values: [
        { title: "Ingredienti semplici",     text: "Pomodori, mozzarella, olio d'oliva, basilico, formaggi, frutti di mare, salumi — tutto fresco, ben scelto, senza superfluo." },
        { title: "Atmosfera che resta",      text: "Murales colorati, verde sul soffitto, luce calda, sedie morbide. Un interno a cui si vuole tornare." },
        { title: "Ospitalità all'italiana",  text: "Servizio tranquillo, tempo per parlare, cibo condiviso a tavola. Come a Roma o a Milano." },
      ],
      quote: '"L\'interno, il murale colorato, la luce calda e il sapore d\'Italia — Segreto è un posto che resta nella memoria."',
      info1Title: "Posizione",
      info2Title: "Orari di apertura",
      info3Title: "Perfetto per",
      info3Text: "Una cena a due, un pranzo in famiglia, un incontro con amici e una serata davanti a un bicchiere di vino.",
      hoursShort: { mon: "Lunedì", monVal: "Chiuso", weekday: "Mar – Ven", weekdayVal: "14:00 – 22:00", weekend: "Sab – Dom", weekendVal: "12:00 – 22:00" },
      ctaTitle: "Benvenuti al nostro tavolo",
      ctaText: "Prenota un tavolo per cena, un pranzo in famiglia o un incontro con amici. Chiama o scegli un orario comodo.",
    },
    menu: {
      eyebrow: "Menù cibi e bevande",
      title1: "Il menù", title2: "Segreto",
      intro: "Pizza romana, antipasti, pasta, secondi, dolci, caffè, bevande e vino. Tutti i prezzi in PLN.",
      ctaTitle: "Ti piace? Prenota un tavolo.",
      ctaCall: "Chiama",
      callLabel: "Chiama:",
    },
    gallery: {
      eyebrow: "Galleria", title1: "Scopri l'", title2: "atmosfera", title3: "di Segreto",
      text: "Guarda l'interno del ristorante, la pizza romana, la pasta, i dolci, il vino e l'atmosfera del locale. Segreto non è solo un ristorante: è un luogo per un incontro tranquillo a tavola.",
      tags: ["Interni", "Pizza", "Pasta", "Secondi", "Dolci", "Caffè", "Vino", "Incontri"],
    },
    contact: {
      eyebrow: "Contatti", title1: "Contatti", title2: "e posizione",
      lead: "Benvenuti a Segreto Ristorante Italiano a Katowice. Ci trovi nella Pierwsza Dzielnica, in ul. Henryka Mikołaja Góreckiego 13/2U.",
      address: "Indirizzo", phone: "Telefono", hours: "Orari di apertura",
      callCardTitle: "Chiamaci",
      callCardText: "Le prenotazioni dei tavoli e i contatti con il ristorante avvengono esclusivamente per telefono.",
    },
    footer: {
      info: "Informazioni",
      disclaimer: "Menù, prezzi, disponibilità di piatti, bevande e orari di apertura possono variare. Le informazioni sul sito sono a scopo informativo e non costituiscono un'offerta commerciale ai sensi di legge. Si prega di confermare le informazioni aggiornate direttamente in ristorante o con il personale.",
      tagline: "Ristorante italiano a Katowice.",
      blurb: "Pizza romana, pasta, piatti italiani, caffè, bevande, vino e una piacevole atmosfera nella Pierwsza Dzielnica di Katowice.",
      nav: "Navigazione", contact: "Contatti", social: "Social",
      phoneLabel: "Telefono",
      rights: "Tutti i diritti riservati.",
      socialFollow1: "Instagram", socialFollow2: "Facebook", socialFollow3: "Google Maps",
      socialSubtitle3: "Trovaci sulla mappa",
    },
    hours: [
      { day: "Lunedì",    value: "Chiuso" },
      { day: "Martedì",   value: "14:00 – 22:00" },
      { day: "Mercoledì", value: "14:00 – 22:00" },
      { day: "Giovedì",   value: "14:00 – 22:00" },
      { day: "Venerdì",   value: "14:00 – 22:00" },
      { day: "Sabato",    value: "12:00 – 22:00" },
      { day: "Domenica",  value: "12:00 – 22:00" },
    ],
  },

  de: {
    nav: { home: "Startseite", about: "Über uns", menu: "Speisekarte", gallery: "Galerie", contact: "Kontakt", reserve: "Jetzt anrufen" },
    common: {
      viewFullMenu: "Speisekarte ansehen", goToMenu: "Zur Speisekarte", viewMenu: "Speisekarte ansehen",
      callNow: "Jetzt anrufen", callToReserve: "Jetzt anrufen",
      directions: "Route anzeigen", getThere: "So findest du uns",
      learnMore: "Segreto entdecken", moreAboutUs: "Mehr über uns",
      viewGallery: "Galerie ansehen", seeLocation: "Standort ansehen",
    },
    modal: {
      title: "Sprache auswählen", subtitle: "Wybierz język · Choose your preferred language · Scegli la lingua",
      pl: "Polski", en: "English", it: "Italiano", de: "Deutsch",
    },
    home: {
      heroEyebrow: "Pierwsza Dzielnica · Katowice",
      heroTitle1: "Segreto", heroTitle2: "Ristorante", heroTitle2b: "Italiano",
      heroSubtitle: "Ein italienisches Geheimnis im Herzen von Katowice",
      heroText: "Römische Pizza, frische Pasta, italienische Gerichte, Desserts, Kaffee, Wein und eine Atmosphäre, zu der man gerne zurückkehrt.",
      introEyebrow: "Über Segreto",
      introTitle: "Italienische Küche",
      introTitle2: "im Ersten Bezirk",
      introP1: "Segreto Ristorante Italiano ist ein Ort für Menschen, die Geschmack, Atmosphäre und ruhige Begegnungen am Tisch schätzen. Ein gutes Restaurant für ein Abendessen zu zweit, ein Familienessen, ein Treffen mit Freunden oder einen Abend bei Wein.",
      introP2: "Auf der Speisekarte finden Sie römische Pizza, Antipasti, Pasta, Hauptgerichte, Salate, Desserts, Kaffee, Getränke, Bier, Cocktails und Wein.",
      sigEyebrow: "Unsere Speisekarte",
      sigTitle: "Geschmack von Segreto",
      sigIntro: "Wählen Sie etwas Leichtes zum Anfang, eine knusprige römische Pizza, eine aromatische Pasta, ein Hauptgericht oder ein Glas Wein.",
      aboutEyebrow: "Innenraum",
      aboutTitle: "Ein Geschmack Italiens",
      aboutTitle2: "in Katowice",
      aboutP1: "Bei Segreto zählen Einfachheit, Qualität der Zutaten und die Atmosphäre am Tisch. Tomaten, Mozzarella, Olivenöl, Basilikum, Meeresfrüchte, Käse, frische Pasta und knusprige römische Pizza bilden eine von der italienischen Küche inspirierte Speisekarte.",
      aboutP2: "Der Innenraum des Restaurants hat einen eigenen Charakter. Bunte Wandbilder, Grün, warmes Licht und gemütliche Tische schaffen ein Ambiente, das zu einem langen Abendessen, einem Treffen mit Freunden und einem ruhigen Weinabend passt.",
      aboutQuote: '"Eine Atmosphäre, die in Erinnerung bleibt."',
      menuEyebrow: "Speisekarte mit Preisen",
      menuTitle: "Entdecken Sie unsere",
      menuTitle2: "Speisekarte mit Preisen",
      menuText: "Sehen Sie sich die komplette Speisekarte von Segreto Ristorante Italiano an. Wählen Sie römische Pizza, Antipasti, Pasta, ein Hauptgericht, Kaffee, ein Getränk oder einen Cocktail.",
      galleryEyebrow: "Galerie",
      galleryTitle: "Entdecke die Segreto-Atmosphäre",
      galleryText: "Innenraum, Wandbild, Grün, Licht, Pasta, Pizza, Kaffee und Wein. Die Galerie zeigt den echten Charakter des Restaurants.",
      galleryCard: "Italienische Atmosphäre",
      galleryCardText: "Sehen Sie die vollständige Galerie des Restaurants.",
      reserveEyebrow: "Reservierungen",
      reserveTitle: "Tisch reservieren",
      reserveText: "Reservieren Sie einen Tisch per Telefon. Rufen Sie uns an und wählen Sie eine passende Zeit für Ihren Besuch im Segreto Ristorante Italiano.",
      contactEyebrow: "Besuchen Sie uns",
      contactTitle: "Finden Sie uns",
      contactTitle2: "in Katowice",
      contactText: "Segreto Ristorante Italiano befindet sich in Katowice, im Ersten Bezirk, in der ul. Henryka Mikołaja Góreckiego 13/2U.",
      sisterEyebrow: "Unser Ort am Meer",
      sisterTitle: "Pizzeria Calabria",
      sisterTitle2: "in Kołobrzeg",
      sisterText: "Wenn Sie Kołobrzeg besuchen, laden wir Sie auch in unser Schwester-Restaurant Pizzeria Calabria ein. Ein Ort in Meeresnähe, gemacht für Pizza, italienische Aromen und ein ruhiges Essen nach einem Spaziergang an der Ostsee.",
    },
    sigCards: [
      { title: "Römische Pizza", text: "Dünner, knuspriger und krosser Teig, Tomatensauce, Mozzarella und italienische Zutaten." },
      { title: "Antipasti", text: "Prosciutto, Ricotta, Muscheln, Carpaccio, Garnelen und italienische Vorspeisen." },
      { title: "Pasta", text: "Carbonara, Bolognese, Meeresfrüchte, Garnelen, Pesto und klassische italienische Saucen." },
      { title: "Hauptgerichte", text: "Ossobuco, Cotoletta alla Milanese und gegrillte Hähnchenbrust." },
      { title: "Desserts", text: "Ein süßer Abschluss des Menüs — fragen Sie unser Personal nach Details." },
      { title: "Kaffee, Getränke & Wein", text: "Espresso, Cappuccino, Limonade, Bier, Cocktails, Prosecco und Wein." },
    ],
    about: {
      eyebrow: "Über uns",
      title1: "Ein italienisches Restaurant", title2: "mit Charakter",
      lead: "Segreto ist mehr als ein Restaurant. Ein Ort für Menschen, die in ruhiger und angenehmer Atmosphäre gut essen möchten, im Herzen des Ersten Bezirks von Katowice.",
      storyEyebrow: "Unsere Geschichte",
      storyTitle1: "Ein italienisches Geheimnis", storyTitle2: "im Herzen von Katowice",
      storyP1: "Segreto Ristorante Italiano verbindet italienische Aromen mit einem warmen Innenraum und dem modernen Ambiente des Ersten Bezirks in Katowice. Ein Raum für das Mittagessen im Alltag, das Abendessen nach der Arbeit, ein Treffen mit Freunden, ein Familienessen oder einen romantischen Abend.",
      storyP2: "Wir lassen uns von der italienischen Tradition inspirieren — von der knusprigen, dünnen römischen Pizza über frische Pasta und klassische Saucen bis hin zu Hauptgerichten wie Ossobuco oder Cotoletta alla Milanese. Hier zählen Geschmack, Gastfreundschaft und eine Atmosphäre, zu der man gerne zurückkehrt.",
      storyP3: "Wählen Sie etwas Leichtes zum Anfang, teilen Sie eine Pizza am Tisch, greifen Sie zu einem Glas Wein und lassen Sie es ruhig angehen. So isst man in Italien — und so isst man bei Segreto.",
      stat1: "Sorten römischer Pizza",
      stat2: "Signature-Pasta",
      stat3: "Kategorien im Menü",
      stat4: "Erster Bezirk · Katowice",
      highlightsEyebrow: "Was Sie bei Segreto finden",
      highlightsTitle: "Italienische Küche in vier Geschmacksrichtungen",
      highlights: [
        { title: "Römische Pizza",     text: "Dünner, knuspriger und krosser Teig, Tomatensauce, Mozzarella und italienische Zutaten." },
        { title: "Frische Pasta",      text: "Carbonara, Bolognese, Meeresfrüchte, Garnelen, Pesto und klassische italienische Saucen." },
        { title: "Italienische Weine", text: "Prosecco, Hausweine und Frizzante-Cocktails für jeden Anlass." },
        { title: "Italienischer Espresso", text: "Espresso, Cappuccino, Latte und Bombardino — Kaffee im echten italienischen Stil." },
      ],
      valuesEyebrow: "Unsere Philosophie",
      valuesTitle: "Drei Grundsätze, die Segreto ausmachen",
      values: [
        { title: "Einfache Zutaten",     text: "Tomaten, Mozzarella, Olivenöl, Basilikum, Käse, Meeresfrüchte, Wurstwaren — alles frisch, sorgfältig ausgewählt, ohne Überflüssiges." },
        { title: "Atmosphäre, die bleibt", text: "Bunte Wandbilder, Grün an der Decke, warmes Licht, weiche Stühle. Ein Innenraum, zu dem man zurückkehren möchte." },
        { title: "Italienische Gastfreundschaft", text: "Ruhiger Service, Zeit für Gespräche, Essen, das am Tisch geteilt wird. Wie in Rom oder Mailand." },
      ],
      quote: '"Das Interieur, das bunte Wandbild, das warme Licht und der Geschmack Italiens — Segreto ist ein Ort, der in Erinnerung bleibt."',
      info1Title: "Standort",
      info2Title: "Öffnungszeiten",
      info3Title: "Perfekt für",
      info3Text: "Ein Abendessen zu zweit, ein Familienessen, ein Treffen mit Freunden und einen Abend bei Wein.",
      hoursShort: { mon: "Montag", monVal: "Geschlossen", weekday: "Di – Fr", weekdayVal: "14:00 – 22:00", weekend: "Sa – So", weekendVal: "12:00 – 22:00" },
      ctaTitle: "Willkommen an unserem Tisch",
      ctaText: "Reservieren Sie einen Tisch für ein Abendessen, ein Familienessen oder ein Treffen mit Freunden. Rufen Sie an oder wählen Sie eine passende Zeit.",
    },
    menu: {
      eyebrow: "Speise- und Getränkekarte",
      title1: "Die Speisekarte", title2: "Segreto",
      intro: "Römische Pizza, Antipasti, Pasta, Hauptgerichte, Desserts, Kaffee, Getränke und Wein. Alle Preise in PLN.",
      ctaTitle: "Schmeckt? Reservieren Sie einen Tisch.",
      ctaCall: "Anrufen",
      callLabel: "Anrufen:",
    },
    gallery: {
      eyebrow: "Galerie", title1: "Entdecke", title2: "die Atmosphäre", title3: "von Segreto",
      text: "Sehen Sie den Innenraum des Restaurants, römische Pizza, Pasta, Desserts, Wein und die Atmosphäre des Lokals. Segreto ist mehr als ein Restaurant — ein Ort für eine ruhige Begegnung am Tisch.",
      tags: ["Innenraum", "Pizza", "Pasta", "Hauptgerichte", "Desserts", "Kaffee", "Wein", "Treffen"],
    },
    contact: {
      eyebrow: "Kontakt", title1: "Kontakt", title2: "& Standort",
      lead: "Willkommen im Segreto Ristorante Italiano in Katowice. Sie finden uns im Ersten Bezirk, in der ul. Henryka Mikołaja Góreckiego 13/2U.",
      address: "Adresse", phone: "Telefon", hours: "Öffnungszeiten",
      callCardTitle: "Rufen Sie uns an",
      callCardText: "Tischreservierungen und Kontakt mit dem Restaurant erfolgen ausschließlich per Telefon.",
    },
    footer: {
      info: "Informationen",
      disclaimer: "Speisekarte, Preise, Verfügbarkeit von Gerichten, Getränken und Öffnungszeiten können sich ändern. Die Informationen auf der Website dienen lediglich der Information und stellen kein verbindliches Angebot im Sinne des Gesetzes dar. Bitte bestätigen Sie aktuelle Informationen direkt im Restaurant oder beim Personal.",
      tagline: "Italienisches Restaurant in Katowice.",
      blurb: "Römische Pizza, Pasta, italienische Gerichte, Kaffee, Getränke, Wein und eine angenehme Atmosphäre im Ersten Bezirk von Katowice.",
      nav: "Navigation", contact: "Kontakt", social: "Social",
      phoneLabel: "Telefon",
      rights: "Alle Rechte vorbehalten.",
      socialFollow1: "Instagram", socialFollow2: "Facebook", socialFollow3: "Google Maps",
      socialSubtitle3: "Auf der Karte finden",
    },
    hours: [
      { day: "Montag",     value: "Geschlossen" },
      { day: "Dienstag",   value: "14:00 – 22:00" },
      { day: "Mittwoch",   value: "14:00 – 22:00" },
      { day: "Donnerstag", value: "14:00 – 22:00" },
      { day: "Freitag",    value: "14:00 – 22:00" },
      { day: "Samstag",    value: "12:00 – 22:00" },
      { day: "Sonntag",    value: "12:00 – 22:00" },
    ],
  },
};

export default t;
